import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';
import Toasts from './Toasts';
import ComputeContributor from './ComputeContributor';
import { useAuth } from '../hooks/useAuth';
export default function Layout() {
    const { t } = useTranslation();
    const { user, logout } = useAuth();
    const location = useLocation();
    const navRef = useRef(null);
    const [openGroup, setOpenGroup] = useState(null);
    const linkClass = ({ isActive }) => `nav-link ${isActive ? 'active' : ''}`;
    const navGroups = [
        {
            key: 'operations',
            items: [
                { to: '/dashboard', label: t('nav.dashboard') },
                { to: '/encode', label: t('nav.encode') },
                { to: '/decode', label: t('nav.decode') },
            ],
        },
        {
            key: 'channel',
            items: [
                { to: '/calibrate', label: t('nav.calibrate') },
                { to: '/compare', label: t('nav.compare') },
                { to: '/analyze', label: t('nav.analyze') },
            ],
        },
        {
            key: 'compute',
            items: [
                { to: '/orchestrate', label: t('nav.orchestrate') },
                { to: '/browser-decode', label: t('nav.bdecode') },
                { to: '/ecosystem', label: t('nav.ecosystem') },
            ],
        },
    ];
    const isGroupActive = (items) => items.some((item) => location.pathname === item.to || location.pathname.startsWith(`${item.to}/`));
    useEffect(() => {
        setOpenGroup(null);
    }, [location.pathname]);
    useEffect(() => {
        function onPointerDown(event) {
            if (!navRef.current?.contains(event.target)) {
                setOpenGroup(null);
            }
        }
        document.addEventListener('pointerdown', onPointerDown);
        return () => document.removeEventListener('pointerdown', onPointerDown);
    }, []);
    return (_jsxs("div", { className: "layout", children: [_jsxs("header", { className: "topbar", children: [_jsxs(NavLink, { to: "/", className: "brand", children: [_jsx("span", { className: "brand-mark", children: "\u27E8QR\u27E9" }), _jsx("span", { className: "brand-name", children: "GESTIORA" })] }), _jsxs("nav", { className: "topnav", ref: navRef, children: [_jsx(NavLink, { to: "/", className: linkClass, end: true, children: t('nav.home') }), _jsx(NavLink, { to: "/about", className: linkClass, children: t('nav.about') }), user && (_jsx(_Fragment, { children: navGroups.map((group) => {
                                    const active = isGroupActive(group.items);
                                    const open = openGroup === group.key;
                                    return (_jsxs("div", { className: "nav-group", children: [_jsx("button", { type: "button", className: `nav-group-label ${active ? 'active' : ''}`, "aria-haspopup": "menu", "aria-expanded": open, onClick: () => setOpenGroup(open ? null : group.key), children: t(`nav.groups.${group.key}`) }), open && (_jsx("div", { className: "nav-menu", role: "menu", children: group.items.map((item) => (_jsx(NavLink, { to: item.to, className: linkClass, role: "menuitem", onClick: () => setOpenGroup(null), children: item.label }, item.to))) }))] }, group.key));
                                }) }))] }), _jsxs("div", { className: "topbar-actions", children: [_jsx(LanguageSwitcher, {}), user ? (_jsxs(_Fragment, { children: [_jsx(NavLink, { to: "/settings", className: "btn btn-ghost", title: t('nav.settings'), children: t('nav.settings') }), _jsx("button", { type: "button", className: "btn btn-ghost", onClick: () => void logout(), children: t('nav.logout') })] })) : (_jsxs(_Fragment, { children: [_jsx(NavLink, { to: "/login", className: "btn btn-ghost", children: t('nav.login') }), _jsx(NavLink, { to: "/register", className: "btn btn-primary", children: t('nav.register') })] }))] })] }), _jsx("main", { className: "content", children: _jsx(Outlet, {}) }), _jsxs("footer", { className: "footer", children: [_jsx("span", { children: t('footer.tagline') }), _jsx("span", { className: "footer-version", children: "v0.1.0" })] }), _jsx(Toasts, {}), _jsx(ComputeContributor, {})] }));
}
